'use client'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { IconButton } from '@mui/material'
// ----------------------------------------------------------------------

interface PasswordToggleIconProps {
  showPassword: boolean
  onToggle: () => void
  disabled?: boolean
}

export function PasswordToggleIcon({ showPassword, onToggle, disabled }: PasswordToggleIconProps) {
  return (
    <IconButton onClick={onToggle} edge="end" color="primary" disabled={disabled}>
      {showPassword ? (
        <VisibilityOutlinedIcon fontSize="small" />
      ) : (
        <VisibilityOffOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  )
}
